export { default as Diario } from './Diario';
export { default as Intervalo } from './Intervalo';
export { default as Mensal } from './Mensal';
export { default as Unica } from './Unica';

export const Types = { DIARIO: 'DIARIO', INTERVALO: 'INTERVALO', MENSAL: 'MENSAL', UNICA: 'UNICA' };
